import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapAthleteWcupRankingComponent } from './components/bootstrap-athlete-wcup-ranking/bootstrap-athlete-wcup-ranking.component';

const routes: Routes = [
  { path: '', component: BootstrapAthleteWcupRankingComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AthleteWcupRankingRoutingModule { }
